import { Tag } from '@dnb/eufemia';
import { useSearchParams } from 'react-router-dom';

interface FilterTagsProps {
  stage?: string[];
  classification?: string[];
  serviceDomainId?: string[];
  tags?: string[];
}

export function FilterTags({ stage = [], classification = [], serviceDomainId = [], tags = [] }: FilterTagsProps) {
  const [, setSearchParams] = useSearchParams();

  function removeFilterValue(filterKey: string, value: string) {
    setSearchParams((prev) => {
      const values = prev.getAll(filterKey);
      const updatedValues = values.filter((v) => v !== value);

      prev.delete(filterKey);
      updatedValues.forEach((v) => prev.append(filterKey, v));

      prev.delete('page');
      return prev;
    });
  }

  if (stage.length === 0 && classification.length === 0 && serviceDomainId.length === 0 && tags.length === 0) {
    return null;
  }

  return (
    <div>
      <Tag.Group label="Filters" top="x-small">
        {stage.map((s) => (
          <Tag key={s} onClick={() => removeFilterValue('stage', s)} variant="removable">
            {s}
          </Tag>
        ))}
        {classification.map((c) => (
          <Tag key={c} onClick={() => removeFilterValue('classification', c)} variant="removable">
            {c}
          </Tag>
        ))}
        {serviceDomainId.map((id) => (
          <Tag key={id} onClick={() => removeFilterValue('serviceDomainId', id)} variant="removable">
            {id}
          </Tag>
        ))}
        {tags.map((tag) => (
          <Tag key={tag} onClick={() => removeFilterValue('tags', tag)} variant="removable">
            {tag}
          </Tag>
        ))}
      </Tag.Group>
    </div>
  );
}
